<template>
  <step
    :context="context"
    image="/images/alarm-clock.svg"
    @back="$emit('back')"
    @submit="submit"
  >
    <template #guideDescription>
      <div>
        <b>6. Customer Portal — </b>
        The customer portal is a web portal,
        allows your loyalty members to access their benefits,
        point balance and lets new customers sign up for your loyalty program.
      </div>
    </template>
    <template #formTitle>Gifts and Special Promotions</template>
    <template #form>
      <v-form v-model="valid" ref="form">
        <form-section
          header="6. Customer Portal— Look & Feel"
          tooltip="Choose design for Customer Portal"
          class="discount-section">
          <div class="inline ma-0 pa-0">
            <div>View Mode - {{model.design.darkViewMode? 'Dark' : 'Light'}}</div>
            <v-switch
              class="customSwitch"
              v-model="model.design.darkViewMode"
              label="(toggle to switch)"
              hide-details
            ></v-switch>
          </div>
          <div class="d-sm-block d-md-flex pa-1">
            <div class="ma-2">
              <div class="ma-2">Primary Color</div>
                <v-color-picker
                  hide-mode-switch
                  class="ma-2"
                  width="240px"
                  canvas-height="80px"
                  dot-size="10"
                  v-model="model.design.colors.primary.rgba"
                ></v-color-picker>
              </div>
              <div class="ma-2">
              <div class="ma-2">Secondary Color</div>
                <v-color-picker
                  hide-mode-switch
                  class="ma-2"
                  width="240px"
                  canvas-height="80px"
                  dot-size="10"
                  mode='rgba'
                  v-model="model.design.colors.secondary.rgba"
                ></v-color-picker>
              </div>
          </div>
          <div class="ma-2">
            <div class="ma-2">Logo</div>
            <v-file-input
                @change="addFile()"
                :placeholder="getPlaceHolder()"
                v-model="logoFile"
                small-chips
                show-size
                accept="image/png, image/jpeg"
                :rules="[rules.fileRequired]"
            />
            <div class="hint">* We recommend to use transparent background logo</div>
            <div class="ma-2">
              <v-img v-if="model.design.logo !== null" :src="model.design.logo" />
            </div>
          </div>
        </form-section>
      </v-form>
    </template>
  </step>
</template>

<script>
import Step from "../Step";
import FormSection from "../FormSection";
import displayMixin from "@/mixins/display";
import axios from "axios";

export default {
  props: ["context"],
  mixins: [displayMixin],
  components: {
    Step,
    FormSection,
  },
  data() {
    const required = (v) => !!v || "Field is required";
    return {
      valid: false,
      rules: {
        required,
        number: (v) =>
          v == null || !isNaN(Number(v)) || "Value must be a number",
        fileRequired: value => !!value || !!this.model.design.logo || 'File is required!',
      },
      logoFile: null,
      model: {
        design: {
          darkViewMode: false,
          colors:{
            primary: {
              rgba: { r: 0, g: 0, b: 0, a: 1 },
            },
            secondary:{
              rgba: { r: 255, g: 255, b: 255, a: 1 },
            }
          },
          logo : null,
          fileName: null,
        },
        ...this.context.submittedData,
      },
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate())
        this.$emit("done", { ...this.$data.model });
    },
    addFile() {
      const reader = new FileReader();
      this.upload = function (event) {
        this.fileData = event.target.result;
        try {
          axios.post(`/api/uploadFile`, {file: this.fileData}).then(response => {
            this.model.design.logo = response.data.fileUrl;
            this.model.design.fileName = this.logoFile.name;
          }).catch(error => {
            console.log(`Failed getting url for file: ${error}`);
            this.model.design.logo = null;
          });
        } catch (e) {
          console.log(`Failed uploading file: ${e}`);
          this.model.design.logo = null;
        }
      };
      this.upload = this.upload.bind(this);
      reader.addEventListener("load", this.upload, false);

      if (this.logoFile) {
        reader.readAsDataURL(this.logoFile);
      }
    },
    getPlaceHolder(){
      return this.model.design.fileName? this.model.design.fileName : "JPEG or PNG File"
    },
  }
};
</script>

<style lang="scss" scoped>
.promote-section {
  .times {
    top: -14px !important;
    position: relative;
    .hint {
      margin-top: 4px !important;
    }
    ::v-deep input {
      max-width: 100px;
    }
    #app.mobile & {
      top: 12px !important;
    }
  }
}
.discount-section {
  .hint {
    #app.mobile & {
      margin-top: 12px;
    }
  }
}
</style>
